import PropTypes from "prop-types"
import { get } from "lodash"
import { formatLongDate, formatIntradayLatestPriceTimestamp } from "helpers/formatters/dates"
import { DATE } from "helpers/shapes"
import TooltipItem from "./item"

function AnalyzeTooltip({ datum, items, formatter, focusedChartLine, isOneDayMode, hasDotClick }) {
  if (datum) {
    const headerText = isOneDayMode ? formatIntradayLatestPriceTimestamp(datum.date) : formatLongDate(datum.date)
    const focusedItem = hasDotClick && focusedChartLine ? items.find(i => i.id === focusedChartLine && !i.disabled) : null
    return <div className="components_analyze-tooltip">
      <div className="header">{headerText}</div>
      {items.map(item => !item.disabled && <TooltipItem
        key={item.id}
        value={get(datum, item.id, "--")}
        {...item}
        focused={focusedChartLine}
        formatter={formatter}
      />,
      )}
      {focusedItem && <div className="drilldown-hint">View {focusedItem.label} contributors</div>}
    </div>
  } else {
    return null
  }
}

AnalyzeTooltip.propTypes = {
  formatter: PropTypes.func,
  focusedChartLine: PropTypes.string,
  hasDotClick: PropTypes.bool,
  datum: PropTypes.shape({
    date: DATE.isRequired,
    index: PropTypes.number,
  }),
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  })).isRequired,
  isOneDayMode: PropTypes.bool,
}

export default AnalyzeTooltip
